import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('General');

export const CONSUMABLETYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.ConsumableType.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('code', 'Entity.ConsumableType.Code')
    .required()
    .maxLength(10)
    .build(),
  FieldBuilder
    .checkbox('mustBeSentToSap', 'Entity.ConsumableType.MustBeSentToSAP')
    .build(),
];

export const CONSUMABLETYPE_CONFIG = {
  entityName: 'ConsumableType',
  localizationKey: 'General::Entity.ConsumableType',
  fields: CONSUMABLETYPE_FIELDS,
  permission: 'GeneralConsumables.ConsumableTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.General + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Consumables + MENU_NAME_SUFFIX,
};
